import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "q-pa-sm flex flex-center bg-white q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_report_post = _resolveComponent("report-post")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_async_items_loader, {
      task: _ctx.task,
      "num-items": _ctx.reportPosts.length
    }, {
      default: _withCtx(() => [
        _createTextVNode(" This report has no posts. ")
      ]),
      _: 1
    }, 8, ["task", "num-items"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportPosts, (reportPost) => {
      return (_openBlock(), _createBlock(_component_report_post, {
        key: reportPost.id,
        "report-post": reportPost,
        comment: reportPost.comment,
        "onUpdate:comment": ($event: any) => ((reportPost.comment) = $event),
        class: "q-my-md",
        onTrashed: _ctx.trash,
        onRestored: _ctx.restore
      }, null, 8, ["report-post", "comment", "onUpdate:comment", "onTrashed", "onRestored"]))
    }), 128)),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_pagination, {
        modelValue: _ctx.page,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
        total: _ctx.total,
        "per-page": _ctx.limit,
        "direction-links": "",
        "boundary-links": "",
        class: "bg-white"
      }, null, 8, ["modelValue", "total", "per-page"])
    ], 512), [
      [_vShow, _ctx.total]
    ])
  ]))
}